import React from "react";
import DataTable from "react-data-table-component";
import ClipLoader from "react-spinners/ClipLoader";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { TbEdit, TbSettings, TbTrash } from "react-icons/tb";
function Table({
  load,
  data,
  total,
  handlePageChange,
  handlePerRowsChange,
  toggleModal,
  toggleModalDelete,
}) {
  const paginationOptions = {
    rowsPerPageText: "Данных на странице:",
    rangeSeparatorText: "из",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: "Все",
  };
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Код</span>,
      selector: (row) => row.Id,
      sortable: true,
      width: "10%",
    },
    {
      name: <span className="font-weight-bold fs-13">Наименование</span>,
      selector: (row) => row.Fio,
      sortable: true,
      width: "55%",
    },
    {
      name: <span className="font-weight-bold fs-13">Должность</span>,
      selector: (row) => row.JobTitle,
      sortable: true,
      width: "25%",
    },
    {
      name: <span className="font-weight-bold fs-13">Действия</span>,
      sortable: false,
      width: "10%",
      center: true,
      compact: true,
      cell: (cellProps) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-outline-secondary btn-sm d-flex justify-content-center"
              tag="button"
            >
              <TbSettings size={18} />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                className="edit-item-btn"
                onClick={() => toggleModal(cellProps)}
              >
                <TbEdit size={16} className="me-2" />
                Изменить
              </DropdownItem>
              <DropdownItem
                className="trash-item-btn"
                onClick={() => toggleModalDelete(cellProps)}
              >
                <TbTrash size={16} className="me-2" />
                Удалить
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      progressComponent={<ClipLoader />}
      progressPending={load}
      paginationTotalRows={total}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      pagination
      paginationServer
      paginationComponentOptions={paginationOptions}
    />
  );
}

export default Table;
